import React from 'react';
import { ApplicationView as view } from '@aha-app/mvc';
import { sharedDragController } from '../controllers/DragController';
import type ListDropHandler from '../ListDropHandler';
import { type SelectableItemController } from '../SelectableItem';
import ListPreviewDropTarget from './ListPreviewDropTarget';
import styles from './styles.module.css';
import type DraggableItem from '../DraggableItem';
import classNames from 'classnames';

export type DragPreviewItemProps = {
  // The drag item being previewed
  dragItem: DraggableItem;
  // The DropHandler for the current hovered item.
  dropHandler: ListDropHandler<SelectableItemController>;
};

const DragPreviewItem: React.FC<DragPreviewItemProps> = ({
  dragItem,
  dropHandler,
}) => {
  const DragPreviewComponent =
    sharedDragController.getDragComponentForItem(dragItem);

  if (!DragPreviewComponent) {
    throw new Error(`No card component registered for ${dragItem.type}`);
  }

  return (
    <ListPreviewDropTarget
      className={classNames(styles.dragPreviewItem, 'drag-preview-item')}
      dropHandler={dropHandler}
    >
      <DragPreviewComponent
        key={dragItem.id}
        dragItem={dragItem}
        selectableItem={dragItem}
        selected
        hoverDropHandlerType={dropHandler.type}
        hoverDropHandler={dropHandler}
        dragPreview
      />
    </ListPreviewDropTarget>
  );
};

export default view(DragPreviewItem);
